export default "__VITE_ASSET__DIwCWHNx__"